import { IFpLoggerNoiseData } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/interfaces/fp-logger-noise-data';

export enum FpLoggerNoiseSummaryActionType {
  GetData = 'GetData',
  GetDataSuccesses = 'GetDataSuccesses',
}

export interface FpLoggerNoiseSummaryActionGetData {
  type: FpLoggerNoiseSummaryActionType.GetData;
  date: string | null;
  popupMainData: IFpLoggerNoiseData | null;
}

export interface FpLoggerNoiseSummaryActionGetDataSuccesses {
  type: FpLoggerNoiseSummaryActionType.GetDataSuccesses;
  date: string | null;
  data: IFpLoggerNoiseData | null;
}

export type FpLoggerNoiseSummaryActions =
  | FpLoggerNoiseSummaryActionGetData
  | FpLoggerNoiseSummaryActionGetDataSuccesses;
